const variableBasePath = '/variable-lists';


const VariableConst = {
  basePath: variableBasePath,
};


export default VariableConst;